import PaystackPop from '@paystack/inline-js';
import {JqueryApp} from "../JqueryApp";
import {Payment, isSuccess} from "../structs/Payment";
import {logger} from "../utils/Log";
import {AbstractGateway} from "./AbstractGateway";

export class GatewaySa extends AbstractGateway { // PayStack
    protected static readonly FRAME_SIZE = 1050;

    protected ps: PaystackPop = null;
    protected transaction: any = null;
    protected checkPaymentStatusTimer: number = 0;
    protected paymentCheckStatusCount: number = 0;

    constructor(app: JqueryApp) {
        super(app);
    }

    public connectForm() {
        const paymentForm = document.getElementById('paymentForm');
        //paymentForm.addEventListener("submit", payWithPaystack, false);
        //this.app.$(paymentForm).submit();
        if (this.app.$(paymentForm).length === 0)
            return;

        this.sendPayment();
        this.sendSizeFrameMessage(GatewaySa.FRAME_SIZE);
        this.app.$(paymentForm).on("submit", (e) => {
            this.sendPayment(e);
        });
    }

    // ################################################################
    // ###################### PRIVATE FUNCTIONS #######################

    protected sendPayment(e?: any) {
        if (e)
            e.preventDefault();

        const config = this.app.getConfig();
        if (!config.gateway || !config.gateway.key) {
            window.alert(this.app.getTr().get("gatewayConfigError"));
            return;
        }

        this.ps = new PaystackPop();
        const tx = this.ps.newTransaction({
            key: config.gateway.key,
            email: config.payment.email,
            amount: config.payment.amountGateway * 100,
            currency: 'ZAR', // NGN, GHS, ZAR or USD // config.payment.gatewayCurrency,
            ref: config.payment.token + "-" + config.payment.merchantId, // twice number
            channels: ['card'], // ['card', 'bank', 'ussd', 'qr', 'mobile_money', 'bank_transfer']
            //channels: 'card', // invalid
            //metadata: {},
            label: config.payment.descGateway, // replaces customer email on checkout form

            //first_name: "Daniel", // not stored
            //last_name: "King",
            //phone: "",

            onLoad: (transaction) => {
                // not firing
            },
            onError: (error) => {
                console.log("PAY ERROR", error)
            },
            onSuccess: (transaction) => {
                // transaction.reference
                console.log("PAID", transaction);
                this.transaction = transaction;
                this.checkPaymentStatus(config.payment);
            },
            onCancel: () => {
                // user closed popup
                console.log("customer cancelled payment") // TODO notify cancel or just let it expire/try again?
                this.app.$("#confirm-purchase-gateway").fadeIn("slow");
            },
            onBankTransferConfirmationPending: () => {

            }
        });
        if (tx && tx.parameters) {
            this.removeGrayOverlay();
            if (isSuccess(config.payment)) {
                logger.info("Skipping payment updates for payment status %s", config.payment.status);
                return;
            }
            setTimeout(() => { // delay to ensure server knows reference
                    this.pingPayment(config.payment, tx.parameters.ref);
                },
                3000);
            this.transaction = tx;
            setTimeout(() => {
                    this.scheduleCheckPayment();
                }
                , 9*1000); // higher initial delay
        }
    }

    /**
     * Notify the server that a payment has been initiated.
     * @param payment
     * @param reference
     * @protected
     */
    protected pingPayment(payment: Payment, reference: string) {
        const config = this.app.getConfig();
        const fullToken = payment.token + "-" + payment.merchantId;
        const url = config.apiBase + config.pathUpdatePayment + "/" + fullToken;
        const data = {
            ref: reference,
        };
        this.webHelpers.getApi(url, data, (data) => {
            //console.log("PAYMENT PINGED", data);
            if (!data || data.error) {
                console.error("Error during payment refresh", data);
                return;
            }
        });
    }

    /**
     * Confirm if a payment has been made with the server.
     * @param payment
     * @param transaction
     * @protected
     */
    protected checkPaymentStatus(payment: Payment) {
        clearTimeout(this.checkPaymentStatusTimer);
        this.checkPaymentStatusTimer = 0;
        if (this.paymentCheckStatusCount > this.app.getConfig().maxCheckStatusCount) {
            console.error("Reached max check status count %d", this.paymentCheckStatusCount);
            return;
        }

        const config = this.app.getConfig();
        const fullToken = payment.token + "-" + payment.merchantId;
        const url = config.apiBase + config.pathPayRefresh + "/" + fullToken;
        const data = {
           //ref: this.transaction.reference, // not set when opening the page
            ref: fullToken,
        };
        this.webHelpers.getApi(url, data, (data) => {
           //console.log("PAYMENT REFRESHED", data);
            this.scheduleCheckPayment();
            this.paymentCheckStatusCount++;
           if (!data || data.error) {
               console.error("Error during payment refresh", data);
               return;
           }

          if (data.payment.status === "PAID" || data.payment.status === "DECLINED") {
              const urlStr = config.pathPayDone + "/" + fullToken + window.document.location.search;
              clearTimeout(this.checkPaymentStatusTimer);
              window.location.assign(urlStr);
          }
        }).fail((err) => {
            console.error("Error during payment refresh", err);
            this.scheduleCheckPayment();
        });
    }

    protected scheduleCheckPayment() {
        clearTimeout(this.checkPaymentStatusTimer);
        this.checkPaymentStatusTimer = window.setTimeout(() => {
            this.checkPaymentStatus(this.app.getConfig().payment);
        }, this.app.getConfig().checkStatusIntervalSec * 1000);
    }

    protected removeGrayOverlay() {
        this.app.$("body iframe").each((i, el) => {
            const $el = this.app.$(el);
            if ($el.attr("src") === undefined && $el.attr("allowtransparency") !== undefined) {
                $el.remove();
            }
            const popup = $('iframe[src="https://checkout.paystack.com/popup"]').detach();
            this.app.$('#paymentForm').append(popup);
            popup.css('display', 'block');
            popup.css('position', 'inherit');
            popup.css('width', '100%');
            popup.css('height', '100%');
            //popup.css('min-height', '630px');
            popup.addClass("scrollablePayFrame");
            popup.css('margin-bottom', '20px');

            this.app.$("#confirm-purchase-gateway").css("display", "none");
        });
    }
}
